export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/Login.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/login/ForgotPassword.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/reset-password/:email',
    name: 'reset-password',
    component: () => import('@/views/login/ResetPassword.vue'),
    meta: {
      layout: 'full',
    },
  },
]
